import { createFileRoute, redirect } from '@tanstack/react-router'
import { getRestoreTarget } from '@/lib/session-restore'

// Root `/` — where every native cold start lands (the WebView has no
// URL to preserve). If the organizer was mid-session in an event,
// session restore puts them back; otherwise fall through to the events
// picker. The `/events/$eventId` guard re-verifies event access on the
// restored path, so every restore validation failure still lands on
// the picker, i.e. the old behavior. See src/lib/session-restore.ts.
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      const restored = getRestoreTarget()
      if (restored) {
        throw redirect({ to: restored })
      }
      throw redirect({ to: '/events' })
    } else {
      throw redirect({ to: '/auth/login', search: { redirect: '/events', activated: undefined } })
    }
  },
})
